<span class="am-flex-align hover-active relative"
      [style.min-height]="item.children ? '' : '50px'"
      [ngClass]="{'am-flex-shrink-0': item.children,
                  'am-flex-1':       !item.children,
                  'am-flex-column am-flex-justify-center gap-xs pt-xs pb-xs': sidebarMinified,
                  'gap-m gap-xs-mobile pt-s pb-s':                           !sidebarMinified,
                  'am-flex-row-i': item.counter && sidebarMinified }"
  (click)="callbackHandler()">
  @if (item.icon       ) { <span class="am-flex-center font-icon {{ item.icon }}" [ngClass]="isActive(item) ? 'color-blue' : item.extra ? 'color-orange' : 'color-title-grey'"></span> }
  @if (!sidebarMinified) { <span class="am-flex-1 width-full"                     [class.color-blue]="isActive(item)">{{ item.title }}</span> }
  @if (item.counter || item.children && sidebarMinified) {
    <span class="am-flex-center"
         [class.hide]="!getReportsCount(item)"
         [ngClass]="getCounterClass(item)"
         [style.top.px]="item.children ? 16 : ''">
      {{ sidebarMinified ? '' : getReportsCount(item) }}
    </span>
  }
  @if (item?.iconRight && !sidebarMinified) { <span class="am-flex-center p-xs font-icon icon-{{ item.iconRight }}"></span> }
  @else {
    <span class="am-flex-center p-xs color-title grey icon-arrow-down"
         [class.hide]="!item.children || item.children.length == 0"
         [class.display-none-i]="sidebarMinified && (!item.children || item.children.length == 0)"
         [class.events-none]="!item.children || item.children.length == 0"
         [class.rotate]="item.collapse"
         (click)="toggleSection($event, item)">
    </span>
  }
</span>

@if (item.children && item.collapse) {
  <div class="am-flex-column text-s mb-s pt-xs pb-xs"  [class.ml-xs]="!sidebarMinified">
    @for (child of item.children; track child) {
      <sidebar-item class="am-flex-align"
                   [ngClass]="sidebarMinified ? 'pl-xxs' : 'pl-m pl-s-mobile'"
                   [class.bl-blue-2]="isActive(child)"
                   [class.bl-table-grey-2]="!isActive(child)"
                   [class.color-orange]="child.extra"
                   [item]="child"
                   [activeTab]="activeTab"
                   [sidebarMinified]="sidebarMinified"
                   [getReportsCount]="getReportsCount"
                   (callback)="callback.emit($event)">
      </sidebar-item>
    }
  </div>
}
